import React from "react";
import Box from "@mui/material/Box";
import LobbyPlayerBox from "./LobbyPlayerBox.jsx";
import LobbyInvitePlayersBox from "./LobbyInvitePlayersBox.jsx";

const FriendSlot = ({
  player,
  slotClass,
  sx,
  onInvite,
  friendsOnline = 0,
  pendingInvite = null,
  onCancelInvite,
  onKick,
  friendlist,
  pendingRequests,
  handleSendRequestFriend,
  lobbyState,
  currentLobbyCode,
  isCurrentUserLeader = false,
  canFlipCards = true,
  showUnavailableActionMessage,
  avatarCacheBust = 0,
}) => {
    return (
      <Box
        component="div"
        className={slotClass || undefined}
        sx={sx}
        onClick={player ? undefined : onInvite}
      >
        {player ? (
          <LobbyPlayerBox 
            player={player} 
            onKick={onKick} 
            friendlist={friendlist} 
            handleSendRequestFriend={handleSendRequestFriend} 
            pendingRequests={pendingRequests}
            lobbyState={lobbyState}
            currentLobbyCode={currentLobbyCode}
            isCurrentUserLeader={isCurrentUserLeader}
            canFlipCards={canFlipCards}
            showUnavailableActionMessage={showUnavailableActionMessage}
            avatarCacheBust={avatarCacheBust}
          />
        ) : (
          <LobbyInvitePlayersBox friendsOnline={friendsOnline} pendingInvite={pendingInvite} avatarCacheBust={avatarCacheBust} onCancelInvite={onCancelInvite} />
        )}
      </Box>
    );
};

export default FriendSlot;
